import {
  React,
  Component,
  PropTypes,
} from 'imports/CommonImports';

import {
  GreyColor1,
  GreyColor2,
  SuccessColorLight,
  PrimaryColor1,
  ShadowColor,
} from 'imports/DesignImports';

import {
  Paper,
  SelectField,
  MenuItem,
} from 'material-ui';

import ReactHighcharts from 'react-highcharts';

const styles = {
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minWidth: '20em',
  },
  header: {
    marginLeft: '1em',
  },
  selectContainer: {
    display: 'flex',
    alignItems: 'center',
  }
}

class ProjectDistributionPerAreaPie extends Component {
  constructor(props){
    super(props);
    this.state = {
      now: new Date(Date.now()),
      colors: [SuccessColorLight,  PrimaryColor1, GreyColor1, ShadowColor,],
      total_per_year: this.props.data.map(data => data.values).reduce((v1, v2, i) => {
        return v1.map((value, i) => value + v2[i])
      }),
      selectedYearIndex: 0,
      years: [(new Date(Date.now())).getFullYear() - 1, (new Date(Date.now())).getFullYear(), (new Date(Date.now())).getFullYear() + 1],
      areas: Array.from(new Set(props.data.map(project => project.area))),
      selectedAreaIndex: 0,
    }
  }


  render() {
    this.props.data.map((data) => {
      return {
        name: data.name,
        y: parseFloat((data.values[this.state.selectedYearIndex]/this.state.total_per_year[this.state.selectedIndex]*100).toFixed(2)),
      }
    })

    return (
      <Paper style={{...styles.paper, ...this.props.style}}>
        <div style={styles.headerContainer}>
          <p style={styles.header}><b>Distribución del aporte económico por proyecto por área y año </b></p>
          <div style={styles.selectContainer}>
            Año:
            <SelectField value={this.state.selectedYearIndex} onChange={this.changeYearSelector} style={{width: 'auto', marginLeft: '1em'}} underlineStyle={{display: 'none'}}>
              {this.state.years.map((year, i) => {
                return <MenuItem key={i} value={i} primaryText={year}/>
              })}
            </SelectField>
          </div>
          <div style={styles.selectContainer}>
            Area:
            <SelectField value={this.state.selectedAreaIndex} onChange={this.changeAreaSelector} style={{width: 'auto', marginLeft: '1em'}} underlineStyle={{display: 'none'}}>
              {this.state.areas.map((area, i) => {
                return <MenuItem key={i} value={i} primaryText={area}/>
              })}
            </SelectField>
          </div>
        </div>

        <ReactHighcharts config={this.config()} ref="chart"/>
      </Paper>
    );
  }

  changeYearSelector = (event, index, value) => {
    this.setState({
      selectedYearIndex: index
    })
  }

  changeAreaSelector = (event, index, value) => {
    this.setState({
      selectedAreaIndex: index
    })
  }

  config = () => {
    return {
      chart: {
          type: 'pie',
          backgroundColor: GreyColor2,
      },
      title: {
          text: '',
      },
      tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      plotOptions: {
          pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                  enabled: false
              },
              showInLegend: true,
              dataLabels: {
                  enabled: true,
                  color: (ReactHighcharts.theme && ReactHighcharts.theme.dataLabelsColor) || 'white',
                  formatter: function () {
                    var string = parseInt(this.percentage, 10) + '%';
                    return string;
                  }
              },
          }
      },
      series: [{
          name: 'Aporte al índice',
          colorByPoint: true,
          data: this.props.data.filter(data => data.area === this.state.areas[this.state.selectedAreaIndex]).map((data) => {
            return {
              name: data.name,
              y: parseFloat((data.values[this.state.selectedYearIndex]/this.state.total_per_year[this.state.selectedYearIndex]*100).toFixed(2)),
            }
          })
      }]
    }
  }
}

ProjectDistributionPerAreaPie.propTypes = {
  style: PropTypes.object,
  data: PropTypes.array,
  indicator: PropTypes.string,
  currency: PropTypes.string,
}

ProjectDistributionPerAreaPie.defaultProps = {
  style: {},
  data: [
    {name: 'Digitalización de procesos financieros', values: [100, 200, 300], area: 'Finanzas'},
    {name: 'Facturación electrónica 2.0', values: [150, 220, 280], area: 'Finanzas'},
    {name: 'Producción en seco de fruta', values: [200, 300, 400], area: 'Operaciones'},
    {name: 'Seguimiento de la producción con uso de blockchain', values: [180, 290, 400], area: 'Operaciones'},
    {name: 'Riego automatizado para campos en pendiente', values: [300, 400, 500], area: 'Innovación'},
    {name: 'Uso de drones para vigilancia de campos', values: [210, 370, 440], area: 'Innovación'},
    ],
  indicator: 'EBITDA',
  currency: 'CLP',
}
export default ProjectDistributionPerAreaPie;



// WEBPACK FOOTER //
// ./src/components/dashboard/ProjectDistributionPerAreaPie.js